import { render, staticRenderFns } from "./NewsPanelControl.global.vue?vue&type=template&id=3e1ba38e&lang=pug&"
import script from "./NewsPanelControl.global.vue?vue&type=script&lang=ts&"
export * from "./NewsPanelControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports